import React, { useEffect, useState } from 'react'
import { Flex, useColorMode } from 'theme-ui'
import PerksSection from '../PerksSection'
import OutroSection from '../OutroSection'
import ClubHouseHero from '~/components/Clubhouse/Hero'
import useWindowSize from '~/hooks/components/use-window-size'

const ClubHousePage = ({ page }) => {
  const [, setColorMode] = useColorMode()
  const { width } = useWindowSize()

  useEffect(() => {
    setColorMode('club-house')
  }, [setColorMode])

  const heroSection = page?.hero
  const sections = page?.sections ?? []
  const typeFormSection = sections.find(
    section => section.slug === 'club-house-typeform',
  )

  return (
    <Flex sx={{ flexDirection: 'column', color: 'secondary' }}>
      {heroSection && (
        <ClubHouseHero
          heroSection={heroSection}
          formId={typeFormSection?.formId}
          width={width}
        />
      )}
      <PerksSection width={width} />
      <OutroSection formId={typeFormSection?.formId} />
    </Flex>
  )
}

export default ClubHousePage
